<template>
  <div
    class="containerFull_badminton"
    id="containerFull_body"
    v-if="currThemeObj"
  >
    <div class="fix_header">
      <platfrom_menu
        :currThemeObj="currThemeObj"
        :selectData="platfromMenu_selectData"
        :userInfor="platfromMenu_userInfor"
        :groupList="platfromMenu_groupList"
        :currGroup="platfromMenu_currGroup"
        :currCid="currCid"
        :currSid="currSid"
        :curPageInitNum="containerFull_curPageInitNum"
        :timeZoneFlag="platfromMenu_timeZoneFlag"
        @changeSidToInitPageEvent="changeSidToInitPage"
        @changeSidEvent="platfrom_changeSid"
        @changeGroupEvent="platfromMenu_changeGroup"
        @timeZoneFlagEvent="platfromMenu_timeZoneFlagEvent"
      ></platfrom_menu>
    </div>
    <div class="mix_body">
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currGroup="platfromMenu_currGroup"
        :groupChangeInitPage="containThemeRouteName"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :curPageInitNum="containerFull_curPageInitNum"
        :bigSportsList="bigSportsList"
        :themeHeaderBannerImage="'scheduleDetail_banner'"
        :curTimeZoneItem="platfromMenu_curTimeZoneItem"
        :sportCompetitionType="sportCompetitionType"
      ></router-view>
    </div>

    <div class="mix_footer">
      <component :is="footerCustomDom" :currThemeObj="currThemeObj" />
    </div>
    <publicThemeDialog
      v-if="isShowPublicThemeDialog"
      :currThemeObj="currThemeObj"
      :isDialogFlag="isShowPublicThemeDialog"
      :dialogObj="publicThemeDialogObj"
      :axiosBaseUrl="axiosBaseUrl"
      :currGroup="platfromMenu_currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :curTimeZoneItem="platfromMenu_curTimeZoneItem"
      @publicThemeDialogEvent="publicThemeDialogHandler"
      @actStyleItemEvent="actStyleItemEventHandler"
    ></publicThemeDialog>
  </div>
</template>

<script>
// 羽毛球 【汤尤杯|苏迪曼杯】 公共容器
import badmintonCommon_data_mixin from '@mixins/badminton/badmintonCommon_data_mixin'

export default {
  name: 'badminton_common',
  props: {
    bigSportsList: {
      type: [Array, null],
      default: null,
    },
    containerFullClassName: {
      type: String,
      default: '',
    },
    defaultPath: {
      type: Array,
      default: () => {
        return []
      },
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
    themeSeasonArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  mixins: [badmintonCommon_data_mixin],
}
</script>

<style lang="scss">
.containerFull_badminton {
  position: relative;
  width: 100%;
  /* height: auto; */
  font-size: 0.972vw;
  max-height: 100vh;
  overflow: auto;
  & .fix_header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1500;
    width: 100%;
    height: 8vw;
    background-color: var(--mixtmt_whiteColor);
  }
  & .mix_body {
    min-height: calc(100vh - 8vw - 9.722vw);
    padding: 0 9.722vw;
  }
  & .mix_footer {
    /* position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1000; */
    width: 100%;
  }
}

.mixtmt_pc {
  .containerFull_badminton {
    /* padding: 8vw 9.722vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
.mixtmt_ipad {
  .containerFull_badminton {
    /* padding: 8vw 3vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
@media screen {
  /* #app.mixtmt_pc {
                .containerFull_badminton {
                }
              } */
}
</style>
